
import { Point } from '../../../../types/types';
import styles from './ConsumerRankingView.module.scss'


export interface ConsumerRankingViewProps {
    list?: Point[]
    onClickConsumer?: (point: Point) => void
}

export default function ConsumerRankingView({list, onClickConsumer}: ConsumerRankingViewProps) {
  return (
    <div className={styles["consumer-ranking"]}>
    <table className={styles["ranking-table"]}>
        <thead className={styles["ranking-table__head"]}>
                <tr className={styles["row-table"]}>
                    <th className={[styles["row-table__cellule"], styles["row-table__cellule--head"]].join(" ")}>Rang</th>
                    <th className={[styles["row-table__cellule"], styles["row-table__cellule--head"]].join(" ")}>Compteur</th>
                    <th className={[styles["row-table__cellule"], styles["row-table__cellule--head"]].join(" ")}>Total<span>(kWh)</span></th>
                </tr>
        </thead>
        <tbody className={styles["ranking-table__body"]}>
        {list?.map((point, index) => (
            <Row point={point} ranking={index + 1} key={index} onClick={() => onClickConsumer && onClickConsumer(point)} />
        ))}
        </tbody>
    </table>
    </div>
  )
}


export const Row = ({point, ranking,onClick }: {point: Point, ranking: number, onClick?: () => void}) => {
    return (
        <tr className={[styles["row-table"], styles["row-table--body"]].join(" ")} onClick={() => {onClick && onClick()}}>
            <td className={[styles["row-table__cellule"],styles["row-table__cellule--ranking"]].join(" ")}>{ranking}</td>
            <td className={styles["row-table__cellule"]}>{point.Values.device_name}</td>
            <td className={styles["row-table__cellule"]}>{point.Values._value}</td>
        </tr>
    )
}